import GalleryBanner from './GalleryBanner'
import ResidentialGallery from './ResidentialGallery'

function ImageGallery() {
  return (
    <div>
      <GalleryBanner />
      <ResidentialGallery />
    </div>
  )
}

export default ImageGallery
